import React from 'react';
import SelectableIcon from 'on_web/components/shared/SelectableIcon/SelectableIcon';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import TextField from 'on_web/components/shared/TextField/TextField';

function SelectableIconList(props) {
  const onCheckboxChange = (val, checked) => {
    if (props.onCheckboxChange) {
      props.onCheckboxChange(val, checked);
    }
  };

  const selectableIcon = (item, index) => {
    return (
      <SelectableIcon
        checked={item.checked}
        value={item.value}
        id={props.id}
        height={props.checkboxHeight}
        width={props.checkboxWidth}
        label={item.label}
        icon={item.icon}
        labelFontSize={props.labelFontSize}
        labelPlacement={props.labelPlacement}
        onCheckboxChange={(val, checked) => onCheckboxChange(val, checked)}
      />
    );
  };

  const renderIcon = (item, index) => (
    <Grid item key={index} xs={props.twoColumns ? 6 : 12} align="center">
      {selectableIcon(item, index)}
    </Grid>
  );

  const renderIconWithTextField = (item, index) => (
    <Grid item key={index} xs={props.twoColumns ? 6 : 12} align="center">
      <Box>
        {selectableIcon(item, index)}
        <TextField
          style={{ marginTop: '12px', marginBottom: '12px' }}
          onChange={e => props.onAnswerMetadata(e.target.value)}
          value={props.value}
          placeholder={props.placeholder}
        />
      </Box>
    </Grid>
  );

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="flex-start">
        {props.items.map((item, index) =>
          props.showMetadata && props.metadataValue === item.value
            ? renderIconWithTextField(item, index)
            : renderIcon(item, index)
        )}
      </Grid>
    </>
  );
}

export default SelectableIconList;
